import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import React from "react";
import ContentNotFound from "../../../../components/mui/general/contentNotFound/contentNotFound";

const AssetsTable = ({ assets = [], t }) => {
	return (
		<ContentNotFound displayContent={assets.length > 0} message={t('No assets found!')}>
			<TableContainer component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
				<Table size="small" aria-label="items table">
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: 'bold' }}>{t('Erp Code')}</TableCell>
							<TableCell sx={{ fontWeight: 'bold' }}>{t('Description')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{assets.map((item, index) => (
							<TableRow key={index}>
								<TableCell>
									{item.ErpCode}
								</TableCell>
								<TableCell>{item.Description}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</ContentNotFound>
	);
};

export default AssetsTable